import React, { Component } from 'react';
import {  Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { loginUserAction } from '../actions/authenticationActions';
import { setCookie,checkCookie } from '../utils/cookies';
import * as Lang from '../lang';
import '../login.css';
class LoginPage extends Component {
   
  onHandleLogin = (event) => {
    event.preventDefault();

    let username = event.target.username.value;
    let password = event.target.password.value;

    const data = {
      username, password
    };

    this.props.dispatch(loginUserAction(data)); 
  }
 

  componentDidMount() {
    document.title = Lang.LANG_TITLE;
  }

  render() {
    let isSuccess, message;
    
    if (this.props.response.login.hasOwnProperty('response')) {
      if(typeof this.props.response.login.response=="undefined"){
        isSuccess=false;
        message="Not connect to server";
      }else{  
        isSuccess = this.props.response.login.response.success;
        message = this.props.response.login.response.message; 
      }
      if (isSuccess) {
        setCookie('token', this.props.response.login.response.data.token, 24);
        localStorage.setItem('name', this.props.response.login.response.data.message.user[0].nickname);
        localStorage.setItem('token', this.props.response.login.response.data.token);
      }
    }
    let user=localStorage.getItem('username');

    return (
      <div className="App"> 
        <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div className="card card-signin my-5">
              <div className="card-body">
                <h5 className="card-title text-center">Đăng nhập</h5>
                {!isSuccess ? checkCookie() === null ? message ? <div className="alert alert-danger" role="alert"> {message} </div>: "" : <Redirect to='dashboard' />: <Redirect to='dashboard' />}
                <form className="form-signin" onSubmit={this.onHandleLogin}> 
                  <div className="form-label-group">
                    <input type="text" id="username" className="form-control" 
                    defaultValue={user}  
                     placeholder="Nhập tài khoản" required />
                    <label htmlFor="username">Tài khoản</label>
                  </div>
                  <div className="form-label-group">
                    <input type="password" id="password" className="form-control" placeholder="Mật khẩu" required />
                    <label htmlFor="password">Mật khẩu</label>
                  </div> 
                  <button className="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Đăng nhập</button>
                  <hr className="my-4" />
                  <p className="text-center">@Family Hospital</p>
              </form>
              </div>
            </div>
          </div>
        </div>
      </div> 
      </div> 

    );
  }
}

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)(LoginPage);